import React from "react"
import PropTypes from "prop-types"

// !scss version of hamburgers is imported in the scss folder!
// import "./hamburgers-master/dist/hamburgers.min.css"

import { useRef, useEffect, useCallback } from "react"

import { Link } from "gatsby"
// import { StaticImage } from "gatsby-plugin-image"

import MenuPDF from "../../images/MENUPDF.pdf"

import "./burger-nav.scss"

const BurgerNav = ({
  expanded,
  children,
  label,
  labelExpanded,
  classNameExpanded,
  className,
  trapFocus,
  onClick,
  onLinkClick,
}) => {
  classNameExpanded = classNameExpanded
    ? className + " " + classNameExpanded
    : className

  const container = useRef()

  const trapFocusCb = useCallback(e => {
    let element = container.current

    var focusableEls = element.querySelectorAll(
      'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
    )
    var firstFocusableEl = focusableEls[0]
    var lastFocusableEl = focusableEls[focusableEls.length - 1]
    var KEYCODE_TAB = 9

    var isTabPressed = e.key === "Tab" || e.keyCode === KEYCODE_TAB

    if (!isTabPressed) {
      return
    }

    if (e.shiftKey) {
      /* shift + tab */ if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.focus()
        e.preventDefault()
      }
    } /* tab */ else {
      if (document.activeElement === lastFocusableEl) {
        firstFocusableEl.focus()
        e.preventDefault()
      }
    }
  }, [])

  useEffect(() => {
    if (trapFocus) {
      if (expanded) container.current.addEventListener("keydown", trapFocusCb)
      else container.current.removeEventListener("keydown", trapFocusCb)
    }
  }, [expanded, trapFocus, trapFocusCb])

  // content styling:

  return (
    <nav
      ref={container}
      className={
        expanded ? "mobile-navigation is-expanded" : "mobile-navigation"
      }
    >
      <button
        onClick={onClick}
        aria-expanded={expanded}
        aria-label="navigation-button"
        className={expanded ? classNameExpanded : className}
        type="button"
      >
        <span className="hamburger-box">
          <span className="hamburger-inner"></span>
        </span>
        {expanded ? labelExpanded : label}
        <div className="burger-overlay"></div>
        <div className="square"></div>
      </button>
      <div>
        <div className="mobile-links">
          <Link onClick={onLinkClick} to="#about" className="nav-link">
            About
          </Link>
          <a href={MenuPDF} className="nav-link">
            Menu
          </a>
          <Link onClick={onLinkClick} to="#events" className="nav-link">
            What's On
          </Link>
          <Link onClick={onLinkClick} to="#contact" className="nav-link">
            Contact
          </Link>
        </div>

        <div className="mobile-social-links">
          <a href="https://www.facebook.com" className="social-link">
            <i className="fab fa-facebook-square"></i>
          </a>
          <a href="https://www.instagram.com" className="social-link">
            <i className="fab fa-instagram-square"></i>
          </a>
          <a href="https://www.twitter.com" className="social-link">
            <i className="fab fa-twitter-square"></i>
          </a>
        </div>
        {children}
      </div>
    </nav>
  )
}

BurgerNav.propTypes = {
  expanded: PropTypes.bool,

  label: PropTypes.string,
  labelExpanded: PropTypes.string,
  classNameExpanded: PropTypes.string,
  className: PropTypes.string,
}

BurgerNav.defaultProps = {
  expanded: false,
  trapFocus: true,
  className: "hamburger hamburger--collapse",
  classNameExpanded: "is-active",
}

export default BurgerNav
